import { SortBy } from '@app/shared/types/pages/friends';
import {
  LeaderboardSortTypeFilter,
  LeaderboardSortOrderFilter,
  LeaderboardFilters,
  MyUserFilters,
} from '@app/store/slices/friends/friendsTypes';

export const LEADERBOARD_FILTERS_SCHEMA: Record<
  keyof LeaderboardFilters,
  (val: unknown) => boolean
> = {
  type: (val) => ['rank', 'cookie', 'ton', 'xp'].includes(val as string),
  isMyTeam: (val) => typeof val === 'boolean',
  sortType: (val) => ['top', 'createdAt'].includes(val as string),
  sortOrder: (val) => ['asc', 'desc'].includes(val as string),
  page: (val) => typeof val === 'number' && Number.isInteger(val) && val > 0,
  limit: (val) => typeof val === 'number' && Number.isInteger(val) && val > 0,
};

export const MY_USER_FILTERS_SCHEMA: Record<keyof MyUserFilters, (val: unknown) => boolean> = {
  type: (val) => ['cookie', 'ton'].includes(val as string),
};

export const SORT_BY_TO_FILTERS_MAP: Record<
  SortBy,
  { sortType: LeaderboardSortTypeFilter; sortOrder: LeaderboardSortOrderFilter }
> = {
  [SortBy.TOP100]: { sortType: 'top', sortOrder: 'desc' },
  [SortBy.REGISTRATION_ASC]: { sortType: 'createdAt', sortOrder: 'asc' },
  [SortBy.REGISTRATION_DESC]: { sortType: 'createdAt', sortOrder: 'desc' },
};

export const FILTERS_TO_SORT_BY_MAP: Record<string, SortBy> = {
  top_desc: SortBy.TOP100,
  createdAt_asc: SortBy.REGISTRATION_ASC,
  createdAt_desc: SortBy.REGISTRATION_DESC,
};
